module.exports = __webpack_public_path__ + "img/main_story_slide2.4dd4d496.jpg";